import { useMemo } from 'react';
import { AppHeader, DemoNotice, ProgressBar } from '../components/common';
import { useT } from '../hooks/useT';
import { useBank } from '../state/BankContext';
import { useProgress } from '../state/ProgressContext';
import { useRouter } from '../state/RouterContext';
import { useSettings } from '../state/SettingsContext';

export function SignsScreen() {
  const t = useT();
  const { navigate } = useRouter();
  const { signs } = useBank();
  const { progress } = useProgress();
  const { settings } = useSettings();

  const learned = useMemo(
    () => signs.filter((s) => progress.signs[s.id]?.status === 'learned').length,
    [signs, progress.signs],
  );

  return (
    <>
      <AppHeader title={t('roadSigns')} />
      <main id="main" className="app-main stack">
        <div className="card card--flat">
          <ProgressBar value={learned} max={signs.length} label={t('signsLearned')} tone="success" />
        </div>

        <div className="tile-grid">
          <button type="button" className="tile tile--primary" onClick={() => navigate({ name: 'signsLearn' })}>
            <span className="tile__icon" aria-hidden="true">
              👀
            </span>
            <span className="tile__label">{t('learnSigns')}</span>
            <span className="tile__chev" aria-hidden="true">
              ›
            </span>
          </button>

          <button
            type="button"
            className="tile"
            onClick={() => navigate({ name: 'quiz', mode: 'signs-test' })}
          >
            <span className="tile__icon" aria-hidden="true">
              ❓
            </span>
            <span className="tile__label">{t('testSigns')}</span>
            <span className="tile__chev" aria-hidden="true">
              ›
            </span>
          </button>
        </div>

        {!settings.easyMode ? <DemoNotice /> : null}
      </main>
    </>
  );
}
